/*
  Zenoura cookie consent controller.

  Source of truth: Shopify.customerPrivacy (Customer Privacy API).

  VIGTIGT (fundet 2026-09-10): API'et ligger IKKE klar paa window.Shopify af
  sig selv. Det skal indlaeses med Shopify.loadFeatures(consent-tracking-api).
  Uden det naaede den besoegendes valg aldrig frem til Shopify: Trekkie
  (Shopifys egen besoegs-taelling) stod i "awaiting-consent" for evigt, og
  butikken har "Indsaml data EFTER samtykke" slaaet til for EU/DK. Resultat:
  0 sessioner i Shopify Analytics, ogsaa for kunder der trykkede
  "Accepter alle", og app-pixels (Meta) startede aldrig.
  Se memory cookie-banner-api-blev-aldrig-indlaest.

  Fallback: localStorage flag so the banner does not re-appear if the API
  call fails or the API is temporarily unavailable. The fallback NEVER
  grants consent — it only records that the visitor has been shown the
  banner and made a choice. Naar API'et senere er tilgaengeligt, skubbes det
  lokale valg til Shopify igen (decideInitial, trin 2).

  Google Tag Manager (partnerens container i theme.liquid) faar samme valg
  via gtag('consent','update') + dataLayer-event 'zenoura_consent_update'.

  Public API:
    window.ZenouraCookies.open()   -> opens the preference panel
    window.ZenouraCookies.reset()  -> clears local fallback (testing only)
*/

(function () {
  "use strict";

  var STORAGE_KEY = "zenoura_consent_v1";
  var ROOT_SELECTOR = "[data-zen-cookie]";
  var API_FEATURE = { name: "consent-tracking-api", version: "0.1" };

  var root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  var bar = root.querySelector("[data-zen-cookie-bar]");
  var panel = root.querySelector("[data-zen-cookie-panel]");
  var overlay = root.querySelector("[data-zen-cookie-overlay]");
  var acceptAllBtn = root.querySelector("[data-zen-cookie-accept-all]");
  var prefsBtn = root.querySelector("[data-zen-cookie-prefs]");
  var saveBtn = root.querySelector("[data-zen-cookie-save]");
  var closeBtn = root.querySelector("[data-zen-cookie-close]");
  var analyticsToggle = root.querySelector('[data-zen-cookie-toggle="analytics"]');
  var marketingToggle = root.querySelector('[data-zen-cookie-toggle="marketing"]');

  // ----------------------------------------------------------------
  // Storage helpers (local fallback only — never the source of truth)
  // ----------------------------------------------------------------

  function readLocal() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeLocal(state) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          analytics: !!state.analytics,
          marketing: !!state.marketing,
          preferences: !!state.preferences,
          sale_of_data: !!state.sale_of_data,
          ts: Date.now(),
        })
      );
    } catch (e) {
      /* swallow — banner will simply re-appear next visit */
    }
  }

  // ----------------------------------------------------------------
  // Shopify Customer Privacy API
  // ----------------------------------------------------------------

  function getPrivacyAPI() {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === "function"
    ) {
      return window.Shopify.customerPrivacy;
    }
    return null;
  }

  // Indlaeser API'et via Shopify.loadFeatures og kalder cb(api|null).
  // loadFeatures defineres af content_for_header i <head>; vi venter kort
  // paa den, hvis den mod forventning ikke er der endnu. Flere kald samles.
  var apiWaiters = [];
  var apiLoading = false;

  function ensurePrivacyAPI(cb) {
    var ready = getPrivacyAPI();
    if (ready) { cb(ready); return; }
    apiWaiters.push(cb);
    if (apiLoading) return;
    apiLoading = true;

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      apiLoading = false;
      var api = getPrivacyAPI();
      var waiters = apiWaiters.slice();
      apiWaiters = [];
      for (var i = 0; i < waiters.length; i++) {
        try { waiters[i](api); } catch (e) {}
      }
    }

    var giveUp = setTimeout(finish, 5000);
    var attempts = 0;
    (function tryLoad() {
      var lf = window.Shopify && window.Shopify.loadFeatures;
      if (typeof lf === "function") {
        try {
          lf([API_FEATURE], function () { clearTimeout(giveUp); finish(); });
        } catch (e) {
          clearTimeout(giveUp); finish();
        }
        return;
      }
      attempts += 1;
      if (attempts > 30) { clearTimeout(giveUp); finish(); return; }
      setTimeout(tryLoad, 100);
    })();
  }

  // Shopify Customer Privacy API records consent per category as one of:
  //   "yes" = consent granted
  //   "no"  = consent denied
  //   ""    = no choice recorded yet
  // A visitor has made a choice only if at least one relevant key is "yes" or "no".
  function hasRecordedShopifyChoice() {
    var api = getPrivacyAPI();
    if (!api || typeof api.currentVisitorConsent !== "function") return false;
    try {
      var c = api.currentVisitorConsent();
      if (!c) return false;
      var keys = ["analytics", "marketing", "preferences", "sale_of_data"];
      for (var i = 0; i < keys.length; i++) {
        var v = c[keys[i]];
        if (v === "yes" || v === "no") return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  // Use Shopify's documented shouldShowBanner() when available so we do not
  // prompt visitors in regions where consent is not required.
  function shopifySaysShow() {
    var api = getPrivacyAPI();
    if (!api || typeof api.shouldShowBanner !== "function") return null;
    try {
      return api.shouldShowBanner() === true;
    } catch (e) {
      return null;
    }
  }

  // Samme valg videre til Google Tag Manager (consent mode v2). Ufarligt hvis
  // GTM ikke er paa siden: dataLayer er bare et array ingen laeser.
  function tellGoogle(consent) {
    try {
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };
      var granted = function (b) { return b ? "granted" : "denied"; };
      gtag("consent", "update", {
        analytics_storage: granted(consent.analytics),
        ad_storage: granted(consent.marketing),
        ad_user_data: granted(consent.marketing),
        ad_personalization: granted(consent.marketing),
        functionality_storage: granted(consent.preferences),
        personalization_storage: granted(consent.preferences),
      });
      window.dataLayer.push({
        event: "zenoura_consent_update",
        zenoura_consent_analytics: !!consent.analytics,
        zenoura_consent_marketing: !!consent.marketing,
      });
    } catch (e) {}
  }

  function applyConsentToShopify(consent, done) {
    tellGoogle(consent);
    ensurePrivacyAPI(function (api) {
      if (!api) {
        // Fail safe: no API => we still record locally so the banner closes.
        // Shopify itself stays without consent (no tracking), and the local
        // record is re-pushed on the next page load (decideInitial, step 2).
        done && done(false);
        return;
      }
      try {
        api.setTrackingConsent(
          {
            analytics: !!consent.analytics,
            marketing: !!consent.marketing,
            preferences: !!consent.preferences,
            sale_of_data: !!consent.sale_of_data,
          },
          function () {
            done && done(true);
          }
        );
      } catch (e) {
        done && done(false);
      }
    });
  }

  // ----------------------------------------------------------------
  // UI
  // ----------------------------------------------------------------

  function show() {
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    // Next frame so the CSS transition runs.
    requestAnimationFrame(function () {
      root.classList.add("zen-cookie--ready");
    });
  }

  function hide() {
    root.classList.remove("zen-cookie--ready");
    root.classList.remove("zen-cookie--panel-open");
    // Allow transition to complete before hiding from layout.
    setTimeout(function () {
      root.hidden = true;
      root.setAttribute("aria-hidden", "true");
      if (panel) panel.hidden = true;
      if (overlay) overlay.hidden = true;
      if (bar) bar.hidden = false;
    }, 240);
  }

  function openPanel(seed) {
    if (analyticsToggle) analyticsToggle.checked = !!(seed && seed.analytics);
    if (marketingToggle) marketingToggle.checked = !!(seed && seed.marketing);

    if (bar) bar.hidden = true;
    if (overlay) overlay.hidden = false;
    if (panel) panel.hidden = false;

    root.hidden = false;
    root.setAttribute("aria-hidden", "false");

    requestAnimationFrame(function () {
      root.classList.add("zen-cookie--ready");
      root.classList.add("zen-cookie--panel-open");
    });
  }

  // ----------------------------------------------------------------
  // Actions
  // ----------------------------------------------------------------

  function acceptAll() {
    var consent = {
      analytics: true,
      marketing: true,
      preferences: true,
      sale_of_data: false,
    };
    writeLocal(consent);
    hide();
    applyConsentToShopify(consent, function () {});
  }

  function savePrefs() {
    var consent = {
      analytics: !!(analyticsToggle && analyticsToggle.checked),
      marketing: !!(marketingToggle && marketingToggle.checked),
      preferences: !!(analyticsToggle && analyticsToggle.checked),
      sale_of_data: false,
    };
    writeLocal(consent);
    hide();
    applyConsentToShopify(consent, function () {});
  }

  // ----------------------------------------------------------------
  // Event wiring
  // ----------------------------------------------------------------

  // Dismissing the preference panel without saving must NOT count as a choice.
  // If consent already exists (visitor opened panel via "Administrer cookies"),
  // close everything. Otherwise return to layer 1 so the visitor still has to
  // make a choice.
  function dismissPanel() {
    if (hasRecordedShopifyChoice() || readLocal()) {
      hide();
      return;
    }
    closePanelReturnToBar();
  }

  function closePanelReturnToBar() {
    root.classList.remove("zen-cookie--panel-open");
    if (overlay) overlay.hidden = true;
    if (panel) panel.hidden = true;
    if (bar) bar.hidden = false;
  }

  if (acceptAllBtn) acceptAllBtn.addEventListener("click", acceptAll);
  if (prefsBtn) prefsBtn.addEventListener("click", function () { openPanel(readLocal() || {}); });
  if (saveBtn) saveBtn.addEventListener("click", savePrefs);
  if (closeBtn) closeBtn.addEventListener("click", dismissPanel);
  if (overlay) overlay.addEventListener("click", dismissPanel);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !root.hidden && root.classList.contains("zen-cookie--panel-open")) {
      dismissPanel();
    }
  });

  // ----------------------------------------------------------------
  // Public API for the "Administrer cookies" footer trigger
  // ----------------------------------------------------------------

  window.ZenouraCookies = {
    open: function () { openPanel(readLocal() || {}); },
    reset: function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    },
  };

  // Re-open trigger from any element with [data-zen-cookie-open]
  document.addEventListener("click", function (e) {
    var target = e.target;
    if (!target) return;
    var trigger = target.closest && target.closest("[data-zen-cookie-open]");
    if (trigger) {
      e.preventDefault();
      window.ZenouraCookies.open();
    }
  });

  // ----------------------------------------------------------------
  // Decide whether to show the banner on load
  // ----------------------------------------------------------------

  function decideInitial() {
    ensurePrivacyAPI(function (api) {
      // 1. Shopify already has a recorded choice => never show.
      if (hasRecordedShopifyChoice()) return;

      // 2. We have a local record but Shopify has no choice (foerste besoeg
      //    efter rettelsen, eller domaene-/lagerskift): skub det til Shopify
      //    uden UI. Den besoegende har allerede svaret os een gang.
      var local = readLocal();
      if (local) {
        applyConsentToShopify(local, function () {});
        return;
      }

      // 3. Region check via documented shouldShowBanner(). When the API is
      //    present and explicitly says false, respect that and stay hidden.
      //    When the API is absent (null) or says true, fall through and show
      //    the banner.
      var apiSays = shopifySaysShow();
      if (apiSays === false) return;

      show();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", decideInitial);
  } else {
    decideInitial();
  }

  // If the visitor's consent changes elsewhere (e.g. Shopify-injected UI),
  // close our banner.
  document.addEventListener("visitorConsentCollected", function () {
    if (!root.hidden) hide();
  });
})();
